import { Crown } from "lucide-react";
import { Link } from "react-router-dom";
import { COMPANY } from "@/lib/siteContent";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#E5E7EB] bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 mb-4">
              <Crown
                className="h-5 w-5 text-[#D4AF7F]"
                strokeWidth={1.5}
              />
              <span className="font-serif text-xl text-[#0F2A44]">
                {COMPANY.name}
              </span>
            </div>
            <p className="text-sm text-[#6B7280] leading-relaxed max-w-sm">
              Premium freight dispatching for owner-operators and small fleets.
              Based in {COMPANY.location}.
            </p>
            <p
              data-testid="footer-legal-name"
              className="mt-4 text-xs uppercase tracking-[0.2em] text-[#6B7280]"
            >
              A service of {COMPANY.legalName}
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.25em] text-[#6B7280] mb-4">
              Contact
            </p>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  href={COMPANY.phoneHref}
                  data-testid="footer-phone"
                  className="text-[#0F2A44] hover:text-[#D4AF7F] transition-colors"
                >
                  {COMPANY.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${COMPANY.email}`}
                  data-testid="footer-email"
                  className="text-[#0F2A44] hover:text-[#D4AF7F] transition-colors break-all"
                >
                  {COMPANY.email}
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.25em] text-[#6B7280] mb-4">
              Legal
            </p>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/privacy"
                  data-testid="footer-privacy"
                  className="text-[#0F2A44] hover:text-[#D4AF7F] transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  data-testid="footer-terms"
                  className="text-[#0F2A44] hover:text-[#D4AF7F] transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#E5E7EB] flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-[#6B7280] tracking-wide">
            © {year} {COMPANY.legalName}. All rights reserved.
          </p>
          <p className="text-xs text-[#6B7280] tracking-wide italic font-serif">
            We find the loads. You drive the miles.
          </p>
        </div>
      </div>
    </footer>
  );
};
